import { UserType } from "@/config";

export default [
  {
    path: "/admin/tenants",
    name: "TenantIndex",
    component: () =>
      import(/* webpackChunkName: "Tenants" */ "@/views/admin/tenants/TenantIndex.vue"),
    children: [
      {
        name: "TenantForm",
        path: ":tenantId",
        component: () =>
          import(
            /* webpackChunkName: "Tenants" */ "@/views/admin/tenants/TenantForm.vue"),
        props: true,
      },
      {
        name: "TenantEdit",
        path: ":tenantId/edit",
        component: () =>
          import(
            /* webpackChunkName: "Tenants" */ "@/views/admin/tenants/TenantForm.vue"),
        props: true,
      },
      {
        name: "TenantUsers",
        path: ":tenantId/users",
        component: () =>
          import(
            /* webpackChunkName: "Tenants" */ "@/views/admin/tenants/TenantUsers.vue"
            ),
        props: true,
      },
    ],
    meta: { allowedUsers: [UserType.CSR], permission: "tenant:admin" },
  }
];